import { useModal, create, show } from "@ebay/nice-modal-react";

import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";
import useStackRoleBindingDelete from "shared/Stack/Roles/useStackRoleBindingDelete";
import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageStack } from "hooks/useAnalytics/pages/stack";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";

type StackRoleUnassignConfirmationProps = {
  id: string;
  name: string;
  refetchQueries: string[];
  source: "drawer" | "table";
  analyticsPage?: AnalyticsPageStack | AnalyticsPageOrganization;
};

const StackRoleUnassignConfirmation = create(function StackRoleUnassignConfirmation({
  id,
  name,
  refetchQueries,
  source,
  analyticsPage = AnalyticsPageStack.StackSettingsRoles,
}: StackRoleUnassignConfirmationProps) {
  const modal = useModal();
  const { reportSuccess } = useTypedContext(FlashContext);
  const trackSegmentEvent = useAnalytics({
    page: analyticsPage,
  });

  const [deleteStackRoleBinding, { loading }] = useStackRoleBindingDelete({
    refetchQueries,
  });

  const handleOnConfirm = () => {
    deleteStackRoleBinding(
      {
        id,
      },
      (data) => {
        if (data?.stackRoleBindingDelete?.id) {
          reportSuccess({
            message: "Role assignment successfully removed",
          });
          trackSegmentEvent("Stack role binding removed", { source });
          modal.resolve();
          modal.hide();
        }
      }
    );
  };

  return (
    <DeleteConfirmationModal
      isLoading={loading}
      isDismissable={!loading}
      title="Unassign role"
      confirmationButtonLabel="Unassign"
      onConfirm={handleOnConfirm}
    >
      <ConfirmationModalMessage>
        Are you sure you want to unassign the role <strong>{name}</strong>? You cannot undo this
        action.
      </ConfirmationModalMessage>
    </DeleteConfirmationModal>
  );
});

export const showStackRoleUnassignConfirmation = (props: StackRoleUnassignConfirmationProps) =>
  show(StackRoleUnassignConfirmation, props);
